const BASE_URL = "https://professionalplacementdesk.com/professionalplacementdesk";
// const BASE_URL = "https://websmileindia.co.in/professionalplacementdesk";
// const BASE_URL = "http://localhost/virendra/professionalplacementdesk";

export default BASE_URL;